module.exports = __webpack_public_path__ + "media/images/riders/small/KATHRIN_STIRNEMANN-283b4ef327b8d47f5744ba14a90fd3ea.png";